function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Route } from 'react-router-dom';
import { getAuthToken } from 'granite-admin/utils/auth-singleton';
import LinearLayout from 'granite-admin/core/components/LinearLayout';
const PublicRoute = ({
  component: Component,
  ...rest
}) => {
  const authToken = getAuthToken();
  if (authToken) {
    // Call getProfile async, so that we can display profile in Header
  }
  return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
    render: props => {
      return /*#__PURE__*/React.createElement(LinearLayout, null, /*#__PURE__*/React.createElement(Component, props));
    }
  }));
};
export default PublicRoute;